import React from 'react';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import styles from 'styles/jss/original/components/ideas/detailPaging';
import { IIdea } from '@/@types/generated/contentful';

const useStyles = makeStyles(styles);

type ComponentProps = {
  idea: IIdea;
  ideaList: IIdea[];
};

const DetailPaging: React.FC<ComponentProps> = ({ idea, ideaList }) => {
  const { num } = idea.fields;
  const classes = useStyles();
  const isFirstPage = num === 1;
  const isLatestPage = num === ideaList.length;
  const prevItem = ideaList.find((item) => item.fields.num === num - 1);
  const nextItem = ideaList.find((item) => item.fields.num === num + 1);
  const prevSlug = prevItem && !isFirstPage ? prevItem.fields.slug : null;
  const nextSlug = nextItem && !isLatestPage ? nextItem.fields.slug : null;

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        {/* @ts-expect-error */}
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={10} md={8} className={classes.justifyContentBetween}>
            {/* @ts-expect-error */}
            <Button round disabled={isFirstPage} className={classes.button}>
              <Link href={`/ideas/${prevSlug}`}>
                <a className={classes.colorWhite}>
                  <ArrowBackIosIcon /> 前の記事を見る
                </a>
              </Link>
            </Button>
            {/* @ts-expect-error */}
            <Button round disabled={isLatestPage} className={classes.button}>
              <Link href={`/ideas/${nextSlug}`}>
                <a className={classes.colorWhite}>
                  次の記事を見る &nbsp; <ArrowForwardIosIcon />
                </a>
              </Link>
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default DetailPaging;
